<template>
  <div class="pa-10">
    <input type="date" v-model="start_date" />
    <input type="date" v-model="end_date" />
    <v-text-field v-model="category" placeholder="カテゴリ"></v-text-field>
        <v-btn depressed color="primary" @click="kaiseki" class="mt-4">
      解析開始
    </v-btn>
    <template>
      <v-data-table
        :items-per-page="itemsPerPage"
        :headers="headers"
        :items="items"
        item-value="name"
        class="elevation-1"
      >
        <!-- <template v-slot:item.pageTitle="{ item }">
                <v-btn outlined class="transparent">
                  <v-icon small color="primary">fas fa-edit</v-icon>
                </v-btn>
              </template> -->

        <!-- <template v-slot:item="{ item }">
          <tr>
            <td class="text-left">
              {{ item.pagePathPlusQueryString }}
            </td>
            <td class="text-left">
              {{ item.pageTitle }}
            </td>
            <td class="text-center">
              {{ item.screenPageViews }}
            </td>
          </tr></template
        > -->
      </v-data-table></template
    >

    <v-divider></v-divider>


  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "Discord",
  data() {
    return {
      start_date: "",
      end_date: "",
      category:"",

      items: [],

      itemsPerPage: 50,
      headers: [
        {
          text: "pagePathPlusQueryString",
          value: "pagePathPlusQueryString",
        },
        { text: "pageTitle", align: "", value: "pageTitle" },

        { text: "screenPageViews", align: "", value: "screenPageViews" },
                { text: "sessions", align: "", value: "sessions" },
                { text: "bounceRate", align: "", value: "bounceRate" },
                                { text: "engagedSessions", align: "", value: "engagedSessions" },


      ],

      // items: [{ items: "222", screenPageViews: "4444" }],
    };
  },
  mounted() {
    var today = new Date();
    today.setDate(today.getDate());
    var yyyy = today.getFullYear();
    var mm = ("0" + (today.getMonth() + 1)).slice(-2);
    var dd = ("0" + today.getDate()).slice(-2);
    this.start_date = yyyy+"-"+mm+"-"+dd;
        this.end_date = yyyy+"-"+mm+"-"+dd;

  },

  methods: {
    kaiseki() {
      var self = this;
      axios
        .get(process.env.VUE_APP_ANAYTICS, {
          params: {
            start_date: self.start_date,
            end_date: self.end_date,
            category: self.category,
          },
        })
        .then(function(response) {
          self.items = response.data;

          console.log(self.items);
        })
        .finally(function() {
          // self.overlay = false;
        });
    },
  },
};
</script>
